<h2 class="sectionTitle">{{'FRONT_USER.SUPPLIER_EVALUATION.REPORT_TITLE'| translate}}</h2>
<div class="services-filter">
  <div class="form-container">
    <h4 class="section-title">{{ 'SHARED.Search' | translate}}</h4>
    <!-- TenderName -->
    <div class="form-group">
      <label for="TenderName">{{ 'FRONT_USER.SUPPLIER_EVALUATION.TENDER_NAME' | translate }}</label>
      <input type="text" id="TenderName" name="TenderName" class="form-control" [(ngModel)]="tenderName" />
    </div>
    <!-- SupplierName -->
    <div class="form-group">
      <label for="CompanyName">{{ 'FRONT_USER.SUPPLIER_EVALUATION.SUPPLIER_NAME' | translate }}</label>
      <input type="text" id="CompanyName" name="CompanyName" class="form-control" [(ngModel)]="supplierName" />
    </div>
    <!-- Supplier response -->
    <div class="form-group">
      <label for="IsSupplierInvolved">{{'FRONT_USER.SUPPLIER_EVALUATION.SUPPLIER_RESPONSE' | translate}}</label>
      <select id="IsSupplierInvolved" name="IsSupplierInvolved" class="form-control" [(ngModel)]="supplierResponse">
        <option [value]="undefined" selected>{{ 'ADMIN_USER.SHARED.CHOOSE' | translate }}
        </option>
        <option [value]="true">
          {{'FRONT_USER.SUPPLIER_EVALUATION.INVOLVED' | translate}}
        </option>
        <option [value]="false">
          {{'FRONT_USER.SUPPLIER_EVALUATION.NORESPONSE' | translate}}
        </option>
      </select>
    </div>
    <!--Involved Supplier  -->
    <div class="form-group">
      <label for="IsMoreThanOneOffer">{{'FRONT_USER.SUPPLIER_EVALUATION.INVOLVED_SUPPLIER' | translate}}</label>
      <select id="IsMoreThanOneOffer" name="IsMoreThanOneOffer" class="form-control" [(ngModel)]="involvedSupplier">
        <option [value]="undefined" selected>{{ 'ADMIN_USER.SHARED.CHOOSE' | translate }}
        </option>
        <option [value]="false">
          {{'FRONT_USER.SUPPLIER_EVALUATION.ONE_OFFER' | translate}}
        </option>
        <option [value]="true">
          {{'FRONT_USER.SUPPLIER_EVALUATION.MORE_THAN_ONE_OFFER' | translate}}
        </option>
      </select>
    </div>
    <!--Technical Offer  -->
    <div class="form-group">
      <label for="IsQualified">{{'FRONT_USER.SUPPLIER_EVALUATION.TECHNICAL_OFFER_EVALUATION' | translate}}</label>
      <select id="IsQualified" name="IsQualified" class="form-control" [(ngModel)]="isQualified">
        <option [value]="undefined" selected>{{ 'ADMIN_USER.SHARED.CHOOSE' | translate }}
        </option>
        <option [value]="true">
          {{'FRONT_USER.SUPPLIER_EVALUATION.QUALIFIED' | translate}}
        </option>
        <option [value]="false">
          {{'FRONT_USER.SUPPLIER_EVALUATION.NOT_QUALIFIED' | translate}}
        </option>
      </select>
    </div>
    <!--	Financial  Offer  -->
    <div class="form-group">
      <label for="IsHighPrice">{{'FRONT_USER.SUPPLIER_EVALUATION.FINANCIAL_OFFER_EVALUATION' | translate}}</label>
      <select id="IsHighPrice" name="IsHighPrice" class="form-control" [(ngModel)]="isHighPrice">
        <option [value]="undefined" selected>{{ 'ADMIN_USER.SHARED.CHOOSE' | translate }}
        </option>
        <option [value]="false">
          {{'FRONT_USER.SUPPLIER_EVALUATION.LOW_PRICE'| translate}}
        </option>
        <option [value]="true">
          {{'FRONT_USER.SUPPLIER_EVALUATION.HIGH_PRICE' | translate}}
        </option>
      </select>
    </div>
    <!--	Winner  -->
    <div class="form-group">
      <label for="IsWinner">{{'FRONT_USER.SUPPLIER_EVALUATION.WINNER' | translate}}</label>
      <select id="IsWinner" name="IsWinner" class="form-control" [(ngModel)]="isWinner">
        <option [value]="undefined" selected>{{ 'ADMIN_USER.SHARED.CHOOSE' | translate }}
        </option>
        <option [value]="true">
          {{'FRONT_USER.SUPPLIER_EVALUATION.WINNER'|translate}}
        </option>
        <option [value]="false">
          {{'FRONT_USER.SUPPLIER_EVALUATION.NOT_WINNER' | translate}}
        </option>
      </select>
    </div>
    <!--supplierNumber-->
    <div class="form-group">
      <label for="SupplierNumber">{{ 'SHARED.REPORTS.SUPPLIER_NUMBER' | translate }}</label>
      <input type="text" id="SupplierNumber" name="SupplierNumber" class="form-control" [(ngModel)]="SupplierNumber" />
    </div>
    <!--fileNumber-->
    <div class="form-group"> 
      <label for="fileNumber">{{ 'ADMIN_USER.E_TENDER_FORM.FILE_NUMBER' | translate }}</label>
      <input type="text" id="fileNumber" name="fileNumber" class="form-control" [(ngModel)]="fileNumber" />
    </div>
  </div>
  <!-- search button -->
  <div class="btns-holder text-center">
    <input type="button" class="btn btn-primary SCAcustomBtn" (click)="loadData()"
      value="{{ 'SHARED.Search' | translate}}" />
    <input type="button" class="btn btn-primary SCAcustomBtn" (click)="resetData()"
      value="{{ 'SHARED.ResetSearch' | translate}}" />
    <input type="button" class="SCAcustomBtn" *ngIf="!hideExportButton" (click)="ExportExcel()"
      value="{{ 'SHARED.REPORTS.EXPORT_EXCEL' | translate}}" />
  </div>
</div>

<app-grid-view #EtenderSupplier [HasMenu]="HasMenu" [customMenuTemplate]="EtenderSupplierTemplate"></app-grid-view>

<ng-template #EtenderSupplierTemplate let-item let-menuItems="menuItems">


  <li role="menuitem">
    <a class="dropdown-item" (click)="View(item.FileNumber)">
      {{'ADMIN_USER.E_TENDER_FORM.VIEW_TENDER'|translate}}
    </a>
  </li>
     
</ng-template>